module.exports = __webpack_public_path__ + "static/media/blind.8704d19e.svg";